import React, { useState } from "react";
import HomeView from "./HomeView";
import GalleryView from "./GalleryView";
import AsaView from "./AsaView";

function App() {
  const [currentView, setCurrentView] = useState("home");

  return (
    <>
      {currentView === "home" && <HomeView setCurrentView={setCurrentView} />}
      {currentView === "gallery" && (
        <GalleryView setCurrentView={setCurrentView} />
      )}
      {currentView === "asa" && <AsaView setCurrentView={setCurrentView} />}
    </>
  );
}

export default App;
